import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

const INSTANCES = document.querySelectorAll(".turbotranslations-modals");

Array.prototype.forEach.call(INSTANCES, el => {
  new Vue({
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount(el)
})
